import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = {
  loading: false,
  error: false,
  currentAlert: null,
};

export default handleActions(
  {
    [Actions.CREATE_SEARCH_ALERT_START]: state => ({
      ...state,
      loading: true,
      error: false,
    }),
    [Actions.CREATE_SEARCH_ALERT_DONE]: (state, { payload: currentAlert }) => ({
      ...state,
      loading: false,
      error: false,
      currentAlert,
    }),
    [Actions.CREATE_SEARCH_ALERT_ERROR]: state => ({
      ...state,
      loading: false,
      error: true,
    }),

    // Fetch user's search alert for current city / country
    [Actions.GET_SEARCH_ALERT_START]: state => ({
      ...state,
      error: false,
      loading: true,
    }),
    [Actions.GET_SEARCH_ALERT_DONE]: (
      state,
      { payload: { currentAlert, error } },
    ) => ({
      ...state,
      loading: false,
      currentAlert,
      error,
    }),
  },
  initialState,
);

export const getIsLoading = state => state.loading;
export const getIsError = state => state.error;
export const getCurrentSearchAlert = state => state.currentAlert;
